/** 0% = opaque, 100% = fully transparent (Object Effects / WMPCM-4886). */
export const TRANSPARENCY_MIN = 0
export const TRANSPARENCY_MAX = 100

export const TRANSPARENCY_RANGE_ERROR = 'Value must be 0-100'

export const TRANSPARENCY_PRESETS = [
  { label: '0%', value: 0 },
  { label: '25%', value: 25 },
  { label: '50%', value: 50 },
  { label: '75%', value: 75 },
  { label: '100%', value: 100 },
] as const

export function opacityFromTransparency(value: number): number {
  return Math.max(0, Math.min(1, 1 - value / 100))
}

export function transparencyFromOpacity(opacity: number | undefined): number {
  const o = typeof opacity === 'number' && Number.isFinite(opacity) ? opacity : 1

  return Math.max(TRANSPARENCY_MIN, Math.min(TRANSPARENCY_MAX, Math.round((1 - o) * 100)))
}

export function matchingTransparencyPreset(n: number): string | null {
  return TRANSPARENCY_PRESETS.find((option) => option.value === n)?.label ?? null
}

export function clampTransparencyPercent(value: number): number {
  return Math.max(TRANSPARENCY_MIN, Math.min(TRANSPARENCY_MAX, Math.round(value)))
}

export function parseTransparencyPercent(raw: string): { ok: true; value: number } | { ok: false } {
  const t = raw
    .trim()
    .replace(/%+\s*$/u, '')
    .trim()

  if (t === '') return { ok: false }
  if (!/^-?\d+(\.\d+)?$/u.test(t)) return { ok: false }
  const n = Number(t)

  if (!Number.isFinite(n)) return { ok: false }
  return { ok: true, value: n }
}

export function isTransparencyPercentInRange(value: number): boolean {
  return value >= TRANSPARENCY_MIN && value <= TRANSPARENCY_MAX
}
